import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-table-header-search',
  templateUrl: './table-header-search.component.html',
  styleUrls: ['./table-header-search.component.less'],
})
export class TableHeaderSearchComponent implements OnInit {
  @Input() searchBy: string;
  @Input() visible: boolean;
  @Input() placeholder: string;

  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onFilterChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onResetFilter: EventEmitter<any> = new EventEmitter<any>();
  constructor() {}

  ngOnInit(): void {}

  filterChange(value) {
    this.onFilterChange.emit(value);
  }

  onVisibilityChange(value) {
    this.visibleChange.emit(value);
  }

  resetFilter(inputSearch) {
    this.onResetFilter.emit({ searchBy: this.searchBy, inputSearch });
  }
}
